import { t } from 'i18next';

export default function getModuleName(name = null) {
  switch (name) {

    case 'items':
      return t('common.total_records.items');
    case 'rawitems':
      return t('common.total_records.rawitems');
    case 'item-groups':
    case 'item_groups':
      return t('common.total_records.item_groups');
    case 'item-adjustments':
      return t('common.total_records.item-adjustments');
    case 'contacts':
      return t('common.total_records.contacts');
    case 'salesorders':
    case 'purchaseorders':
      return t('common.total_records.orders');
    case 'package_listing':
    case 'packages':
      return t('common.total_records.packages');
    case 'invoices':
      return t('common.total_records.invoices');
    case 'bills':
      return t('common.total_records.bills');
    case 'salesreturns':
      return t('common.total_records.salesreturns');
    case 'creditnotes':
      return t('common.total_records.creditnotes');
    case 'mapping':
      return t('common.total_records.mapping');
    case 'paymentsmade':
      return t('common.total_records.paymentsmade');
    default:
      return t('common.total_records.records');
  }
}
